'use strict';

angular.module('shiftTraderApp')
    .directive('saMassUsersPositionEditor', function () {
      return {
        templateUrl: 'views/directives/saMassUsersPositionEditor.html',
        restrict: 'A',
        scope: {
          me:'=loggedInUser',
          org:'=',
          allPositions: '=positions',
          allUsers: '=users'
        },
        link: function(scope) {
          $(document).keydown(function(event) {
            if (event.which === 27) { // ESC
              scope.$apply(scope.clearActiveEmp);
            }
          });

          scope.$on('$destroy', function() {
            $(document).unbind('keydown');
          });
        },
        controller: ['$scope', '$q', '$filter', '$timeout', 'Positions', 'Departments', 'regexStrings', function($scope, $q, $filter, $timeout, Positions, Departments, regexStrings) {

          function setFilteredUsers (users) {
            $scope.filteredUsers = lodash.sortBy(lodash.filter(users, function (emp) {
              return emp.$curMemb().active
            }), 'first_name')
          }

          $scope.regexStrings = regexStrings;
          $scope.redraw = false;

          $scope.filteredUsers = []
          if ($scope.allUsers) {
            setFilteredUsers($scope.allUsers)
          } else {
            var dereg = $scope.$watch('allUsers', function(newVal, oldVal) {
              if (!oldVal && newVal) {
                setFilteredUsers($scope.allUsers)
                dereg()
              }
            })
          }

          $scope.$on('addedEmployees', function (evt, users) {
            setFilteredUsers(users)
          })

          var removeEmptyRows = function() {
            $('.mass_usr_pos_edit_card_row').not(':has(.mass_usr_pos_edit_card_row_title)').remove();
          };

          $timeout(removeEmptyRows, 0);

          // Fill departments with ACTIVE positions that have matching department_id
          $scope.departments = _.map($scope.org.departments, function(dept) {
            dept.positions = _.where($scope.allPositions, {department_id: dept.id, active: true});
            return dept;
          });

          // Provent empty departments from being displayed
          _.remove($scope.departments, function(dept) {
            return dept.positions.length === 0;
          });

          var calculateNumberOfUsersPositions = function(posId) {
            if (_.isUndefined(posId)) {
              posId = $scope.state.selectedPosId;
            }
            return _($scope.filteredUsers).map(function(u) {
              return _.where(u.users_positions, {active: true, position_id: posId});
            }).flatten().__wrapped__.length;
          };

          $scope.calculateNumberOfUsersPositions = calculateNumberOfUsersPositions;

          var isLastPosInDept = function(pos) {
            var deptId = pos.department_id;
            var dept = _.find($scope.departments, {id: deptId});
            var posIdx = _.findIndex(dept.positions, {id: pos.id});

            return posIdx === (dept.positions.length -1);
          };

          var isFirstPosInDept = function(pos) {
            var deptId = pos.department_id;
            var dept = _.find($scope.departments, {id: deptId});
            var posIdx = _.findIndex(dept.positions, {id: pos.id});

            return posIdx === 0;
          };

          var isLastDept = function(dept) {
            var deptIdx = _.findIndex($scope.departments, {id: dept.id});

            return deptIdx === ($scope.departments.length -1);
          };

          var isFirstDept = function(dept) {
            var deptIdx = _.findIndex($scope.departments, {id: dept.id});

            return deptIdx === 0;
          };

          $scope.state = {
            selectedPosId: -1,
            selectedDeptId: -1,
            activeEmpId: -1,
            sortOrder: 'first',
            q: {}
          };
          $scope.sortFields = ['first_name', 'last_name', 'id'];

          $scope.allEmpsByLetter = [
            ['A', 'B', 'C'],
            ['D', 'E', 'F'],
            ['G', 'H', 'I'],
            ['J', 'K', 'L'],
            ['M', 'N', 'O'],
            ['P', 'Q', 'R'],
            ['S', 'T'],
            ['U', 'V', 'W'],
            ['X', 'Y', 'Z']
          ];

          $scope.state.q.isSelectedPos = function(pos) {
            return pos.id === $scope.state.selectedPosId;
          };

          $scope.state.q.isActiveEmp = function(emp) {
            return emp.id === $scope.state.activeEmpId;
          };

          $scope.state.q.firstPosIsSelected = function() {
            var dept = _.find($scope.departments, {id: $scope.state.selectedDeptId});

            if (isFirstDept(dept)) {
              var pos = _.find(dept.positions, {id: $scope.state.selectedPosId});
              return isFirstPosInDept(pos);
            } else {
              return false;
            }
          };

          $scope.state.q.lastPosIsSelected = function() {
            var dept = _.find($scope.departments, {id: $scope.state.selectedDeptId});

            if (isLastDept(dept)) {
              var pos = _.find(dept.positions, {id: $scope.state.selectedPosId});
              return isLastPosInDept(pos);
            } else {
              return false;
            }
          };

          $scope.state.q.selectedPosName = function() {
            return _.find($scope.allPositions, {id: $scope.state.selectedPosId}).name;
          };

          $scope.setActiveEmp = function(emp) {
            $scope.state.activeEmpId = emp.id;
            $scope.currentPos._toggler = !$scope.currentPos._toggler;
            $scope.numberOfSelectedUsersPositions = calculateNumberOfUsersPositions();
          };

          $scope.clearActiveEmp = function() {
            $scope.state.activeEmpId = -1;
          };

          this.isSelectedPos = $scope.state.q.isSelectedPos;
          this.isActiveEmp = $scope.state.q.isActiveEmp;
          this.setActiveEmp = $scope.setActiveEmp;

          this.requestCompleted = function() {
            $scope.numberOfSelectedUsersPositions = calculateNumberOfUsersPositions();
          };

          $scope.setSelectedPos = function(pos) {
            $scope.state.selectedPosId = pos.id;
            $scope.currentPos = pos;
            $scope.state.selectedDeptId = pos.department_id;
            $scope.numberOfSelectedUsersPositions = calculateNumberOfUsersPositions();
            return pos;
          };

          $scope.nextPos = function() {
            if (!$scope.state.q.lastPosIsSelected()) {
              var dept = _.find($scope.departments, {id: $scope.state.selectedDeptId});
              var pos = _.find(dept.positions, {id: $scope.state.selectedPosId});
              var newPos;

              if (isLastPosInDept(pos)) {
                var deptIdx = _.findIndex($scope.departments, {id: $scope.state.selectedDeptId});
                newPos = $scope.departments[deptIdx+1].positions[0];
              } else {
                var posIdx = _.findIndex(dept.positions, {id: pos.id});
                newPos = dept.positions[posIdx+1];
              }

              $scope.setSelectedPos(newPos);
            }
          };

          $scope.previousPos = function () {
            if (!$scope.state.q.firstPosIsSelected()) {
              var dept = _.find($scope.departments, {id: $scope.state.selectedDeptId});
              var pos = _.find(dept.positions, {id: $scope.state.selectedPosId});
              var newPos;

              if (isFirstPosInDept(pos)) {
                var deptIdx = _.findIndex($scope.departments, {id: $scope.state.selectedDeptId});
                var posIdx = $scope.departments[deptIdx-1].positions.length -1;
                newPos = $scope.departments[deptIdx-1].positions[posIdx];
              } else {
                var posIdx = _.findIndex(dept.positions, {id: pos.id});
                newPos = dept.positions[posIdx-1];
              }

              $scope.setSelectedPos(newPos);

            }
          };

          $scope.deselectAllEmps = function () {
            $scope.$broadcast('setEmpSelection', false);
          };

          $scope.selectAllEmps = function () {
            $scope.$broadcast('setEmpSelection', true);
          };


          var redrawTimeout;
          var removeRowTimeout;
          $scope.setSortOrder = function(order) {
            $scope.redraw = true;
            $scope.state.sortOrder = order;
            if ('first' === order) {
              $scope.sortFields = ['first_name', 'last_name', 'id'];
            } else {
              $scope.sortFields = ['last_name', 'first_name', 'id'];
            }

            // If we change the sort order, toggle "redraw" variable to cause
            // Angular to redraw the DOM.
            // Wait some more, and then remove the empty rows again.
            if (!_.isUndefined(redrawTimeout)) {
              $timeout.cancel(redrawTimeout);
            }
            redrawTimeout = $timeout(function() {
              $scope.redraw = false;
              if (!_.isUndefined(removeRowTimeout)) {
                $timeout.cancel(removeRowTimeout);
              }
              removeRowTimeout = $timeout(function() {
                removeEmptyRows();
              }, 0);
            }, 0);

//            sortEmployees();
          };

          $scope.toggleSortOrder = function() {
            if ($scope.state.sortOrder === 'first') {
              $scope.setSortOrder('last');
            } else {
              $scope.setSortOrder('first');
            }
          };


          //find the first position in a department
          _.each($scope.departments, function(dept) {
            var foundPosition = false;
            _.each(dept.positions, function(pos) {
              foundPosition = true;
              $scope.setSelectedPos(pos);
              return false;
            });

            if (foundPosition) {
              return false;
            }
          });

//          sortEmployees();

          $scope.clickedInOpenSpace = function() {
            console.log('clickedInOpenSpace');
            $scope.clearActiveEmp();
          };

        }]
      };
    });
